import React from 'react';
import DynamicInputField from '../../CommonUtils/DynamicInputField'; // We'll create this new component

const MessageA14info = (props) => {
    let infoText = props?.item?.infoText || "Please enter your input here";
    return (
        <div>
            <DynamicInputField
                {...props}
                placeholder={infoText}
                minRows={1} // Minimum rows to show
                maxRows={10} // Maximum rows before scrolling
            />
        </div>
    );
};

export default MessageA14info;